import { Button } from "@/modern/components/ui/button-shadcn";
import { Edit } from "lucide-react";
import { useEntityManagerContext } from "../context/EntityManagerContext";
import { cn } from "@/modern/utils";
import { EntityMoreMenu } from "./EntityMoreMenu";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";
import { EDITOR_KEYS } from "@/other/constants/EditorKeys";
import { ButtonGroup } from "@/modern/components/ui/button-group";
import { EntityNameButton } from "./EntityNameButton";
import { AppActiveUsers } from "../../appHeader/headerButtons/appActiveUsers/AppActiveUsers";

export function EntityTitleBar() {
  const { record } = useEntityManagerContext();
  const { editorHandler } = useSwivuBryntumContext();

  return (
    <div className="w-full border-b px-5 py-3 group bg-accent text-accent-foreground text-base">
      <div className="flex items-center justify-between">
        <div className="space-y-1 flex-1 min-w-0">
          {/* Name with Edit Button */}
          <div className="flex items-center relative font-medium leading-tight gap-2">
            <span className={cn("inline-block truncate max-w-full", record.archived && "line-through")}>{record.name || "N/A"}</span>

            <Button
              size="xs"
              variant="ghost"
              className="opacity-0 group-hover:opacity-100 transition-opacity inline-flex h-6 w-6 p-0"
              onClick={() => {
                if (record.isTask) {
                  editorHandler.openEditor(EDITOR_KEYS.taskEditor, record, { task: record }, { useExisting: true, by: "recordId", className: "dashboard-theme" });
                } else if (record.isResource) {
                  editorHandler.openEditor(EDITOR_KEYS.resourceEditorV2, record, { resource: record }, { useExisting: true, by: "recordId", className: "dashboard-theme" });
                } else if (record.isClient) {
                  editorHandler.openEditor(EDITOR_KEYS.clientEditorV2, record, { client: record }, { useExisting: true, by: "recordId", className: "dashboard-theme" });
                }
              }}
              title="Edit"
            >
              <Edit className="h-3.5 w-3.5" />
            </Button>
          </div>
        </div>
        <div className="flex gap-3">
          <AppActiveUsers />
          <ButtonGroup className="flex-shrink-0 [&_button]:!bg-transparent [&_button]:!border-transparent [&_button:hover]:!bg-accent-foreground/10">
            <EntityNameButton />
            <EntityMoreMenu />
          </ButtonGroup>
        </div>
      </div>
    </div>
  );
}
